import { reduxSetter } from '../../../../../utils/reduxSetter';

const initialState = {
    isLoading: true,
    data: [],
    error: null,
    isLeadTypeUpdate: false
};

export const leadHistory = (state = initialState, action) => {
    switch (action.type) {
    case 'SET_LEAD_HISTORY_DATA':
        return reduxSetter(state, action);
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/leadHistory.reducer.js